module.exports = __webpack_public_path__ + "img/navodila_slika_5.99afbdc0.png";